import React from 'react';
import CourseInfo from './CourseInfo';
import EducationalInfo from './EducationalInfo';


const Educational = () => {

    return (
        <>
            <div className="flex flex-col md:flex-row py-2">
                <EducationalInfo />
                <CourseInfo />
            </div>
        </>
    );
};

export default Educational;